/**
 * Module dependencies.
 */

import { ChangeEvent, forwardRef } from 'react';
import { InputRadio, RadioProps } from './index';
import { UseControllerProps, useController } from 'react-hook-form';
import { assignRefs } from 'src/core/utils/refs';

/**
 * `InputRadioFieldProps` type.
 */

type InputRadioFieldProps = RadioProps &
  Pick<UseControllerProps, 'control' | 'defaultValue' | 'name' | 'rules'> & {
    onChangeNormalizer?: (
      event: ChangeEvent<HTMLInputElement>,
      onChange: (event: ChangeEvent<HTMLInputElement>) => void,
      value: any
    ) => void;
  };

/**
 * Export `InputRadioField` component.
 */

export const InputRadioField = forwardRef((props: InputRadioFieldProps, forwardedRef: any) => {
  const { control, defaultValue = '', name, onChangeNormalizer, rules, value, ...rest } = props;
  const {
    field: { onBlur, onChange, ref },
    fieldState: { error }
  } = useController({
    control,
    defaultValue,
    name,
    rules
  });

  return (
    <InputRadio
      {...rest}
      error={error?.message}
      name={name}
      onBlur={onBlur}
      onChange={
        !onChangeNormalizer
          ? onChange
          : event => onChangeNormalizer(event as ChangeEvent<HTMLInputElement>, onChange, value)
      }
      ref={assignRefs(forwardedRef, ref)}
      value={value}
    />
  );
});

/**
 * `InputRadioField` display name.
 */

InputRadioField.displayName = 'InputRadioField';
